module.exports = __webpack_public_path__ + "media/images/it/icons/history-e969bdd02a1fdfe5088fcf561c1d5fe9.svg";